<template>
  <transition name="slide-fade">
    <div class="box-form " @keypress.enter.prevent>
      <Loading v-show="loading" class="loading" />
      <div class="row px-5 py-3">
        <div
          class="col-12 header p-0 d-flex justify-content-between align-items-center"
        >
          <slot name="header"></slot>
        </div>

        <div class="col-12 mt-4 p-0">
          <form class="">
            <slot></slot>
          </form>
        </div>
        <div
          v-show="error"
          class=" col-12 alert alert-danger mt-3"
          role="alert"
        >
          {{ error }}
        </div>
        <div class="col-12 p-0">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Loading from "./AnimateLoad";

export default {
  name: "BoxForm",
  props: ["messageError", "loading"],
  components: { Loading },
  data() {
    return {
      error: "",
    };
  },
  created() {
    this.error = this.messageError;
  },
  watch: {
    messageError() {
      this.error = this.messageError;
      setTimeout(() => {
        this.error = "";
        this.$emit("clean-error");
      }, 4000);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes dissolve {
  0% {
    opacity: 1;
  }
  75% {
    opacity: 0.9;
  }
  100% {
    opacity: 0;
  }
}
.alert {
  animation: dissolve 4010ms;
}
.box-form {
  border: 1px solid #666;
  border-radius: 0.8rem;
  input,
  select {
    border: 1px solid #666;
  }
  .header {
    font-size: 22px;
    font-weight: 300;
    .icon {
      height: 24px;
      width: 24px;
    }
  }

  .loading{
    width: 98%;
  }
}
</style>
